import {_axios as http} from "./http-common";
import {Ilogin} from "./components/Login";

interface readings {
    "date"? : string,
    "imei" : string,
    "timeZone" : number,
    "category_name":string,
    "startDate"?:string,
    "endDate"?:string,
    "userID"?:string
}

export interface ISignUp{
    "first_name":string,
    "last_name":string,
    "password":string,
    "dob": string,
    "email":string
}

interface profile{
    DoB: string
    firstName: string
    id: number
    lastName: string
    notificationOnAbnormalValues: boolean
    notificationOnNewMeasurements: boolean

}

interface chart{
    mode : string,
    deviceID : string,
    category:string,
    zone:number,
    userID:string
}

interface NormalValues{
    deviceID : number,
    age : number
}

interface NewDevice {
    imei:string,
    alias:string,
    email ? : string
}

export interface Readings {
    id:number,
    data:string | null,
    deviceTime:string,
    injustedtime:string,
    uniqueId ? : number
}

interface UserUpdate{
    first_name:string,
    last_name:string,
    dob:string
}

interface DeleteDevice{
    id:number,
    imei:string
}

interface Latestreadings{
    imei : string,
    name : string
}

interface devicesByAdmin {
    id?:number,
    uuid?:string
}

class RmpServices {

    login(data : Ilogin) {
        return http.post("/auth/signin",data);
    }

    SignUp(data:ISignUp){
        return http.post("/auth/signup",data)
    }



    getReadings(data : readings){
        return http.post("device/GetReadings" ,data)
    }
    GetAllReadings(timeZone:number){
        return http.get(`/device/allReadings/${timeZone}`)
    }
    AddNewDevice(data:NewDevice){
        return http.post("device/add",data)
    }
    GetAlldevices(){
        return http.get("/device/")
    }
    GetdeviceByImei(imei:string){
        return http.get(`/device/${imei}`)
    }

    AddUserDevice(data:NewDevice){
        return http.post("device/add/admin",data)
    }
    GetUserDevices(data:devicesByAdmin){
        return http.get(`/device/user/${data.id}/hashID/${data.uuid}`)
    }

    GetChartData(data : chart){
        return http.get(
            `/device/average/${data.mode}/device/${data.deviceID}/category/${data.category}/timeZone/${data.zone}/userID/${data.userID}`
        )
    }
    DeleteDevice(data : DeleteDevice){
        return http.delete(`/device/delete/${data.id}/imei/${data.imei}`)
    }
    GetLatestReadings(){
        return http.get(`/device/latest/card/values`)
    }


    GetUsersList(){
        return http.get('/users')
    }
    UpdateUser(data:UserUpdate,id:number){
        return http.put(`/users/update/${id}`,data)
    }
    GetAdminsList(){
        return http.get('/users/allAdmins')
    }
    AddUser(data:ISignUp){
        return http.post('/users/create',data)
    }

    GetAllClients(){
        return http.get('/clients')
    }

}
export default new RmpServices();